module.exports = __webpack_public_path__ + "img/16.0b250dc9.jpg";